<template>
    <div>
        <CRow>
            <CCol>
                <div v-if="hasNoAreas">
                    <ejs-grid ref='grid'
                              :dataSource='volumeData'
                              :allowFiltering='true'
                              :allowPaging='true'
                              :allowResizing='true'
                              :allowReordering='true'
                              :allowSorting='true'
                              :toolbar='toolbar'
                              :actionFailure="actionFailure"
                              :editSettings='editSettings'
                              :pageSettings='pageSettings'
                              :filterSettings='filterOptions'
                              :toolbarClick='toolbarClick'
                              :allowExcelExport='true'
                              :excelExportComplete='excelExportComplete'
                              :query='gridQuery'
                              :actionComplete="actionComplete"
                              :actionBegin="actionBegin"
                              :queryCellInfo='customiseCell'>
                        <e-columns>
                            <e-column field='volumeId' headerText='volumeId' :isPrimaryKey='true' :visible='false'></e-column>
                            <e-column field='tradablePeriod' headerText='Tradeable Period' width=120 :allowEditing="false"></e-column>
                            <e-column field='base' headerText='Base' editType="numericEdit" format="n2" :edit="numericBaseParams" :visible='baseVisible' width=120></e-column>
                            <e-column field='peak' headerText='Peak' editType="numericEdit" format="n2" :edit="numericPeakParams" :visible='peakVisible' width=120></e-column>
                            <e-column field='gas' headerText='Gas' editType="numericEdit" format="n2" :edit="numericGasParams" :visible='gasVisible' width=120></e-column>
                            <e-column field='offPeak' headerText='Off-Peak' editType="numericEdit" format="n2" :edit="numericOffPeakParams" :visible='offPeakVisible' width=120></e-column>
                            <e-column field='total' headerText='Total' editType="numericEdit" format="n2" :visible='totalVisible' width=120 :allowEditing="false"></e-column>
                        </e-columns>
                        <e-aggregates>
                            <e-aggregate>
                                <e-columns>
                                    <e-column columnName="base" type="Custom" :customAggregate="calculateSumBase" :footerTemplate='footerTemplate'></e-column>
                                    <e-column columnName="peak" type="Custom" :customAggregate="calculateSumPeak" :footerTemplate='footerTemplate'></e-column>
                                    <e-column columnName="offPeak" type="Custom" :customAggregate="calculateSumOffPeak" :footerTemplate='footerTemplate'></e-column>
                                    <e-column columnName="gas" type="Custom" :customAggregate="calculateSumGas" :footerTemplate='footerTemplate'></e-column>
                                    <e-column columnName="total" type="Custom" :customAggregate="calculateSumTotal" :footerTemplate='footerTemplate'></e-column>
                                </e-columns>
                            </e-aggregate>
                        </e-aggregates>
                    </ejs-grid>
                    <div>
                        <ejs-uploader ref="uploadObj" id='defaultfileupload' name="uploadFile" :allowedExtensions="extensions" :uploading="addHeaders" :asyncSettings="path" :success="onUploadSuccess" :failure="onUploadFailed" :multiple='multiple'></ejs-uploader>
                    </div>
                </div>
                <div v-if="hasAreas">
                    <ejs-grid ref='gridWithArea'
                              :dataSource='volumeData'
                              :allowResizing='true'
                              :toolbar='toolbar'
                              :actionFailure="actionFailure"
                              :editSettings='editSettings'
                              :pageSettings='pageSettings'
                              :filterSettings='filterOptions'
                              :toolbarClick='toolbarClickgridWithArea'
                              :allowExcelExport='true'
                              :excelExportComplete='excelExportCompletegridWithArea'
                              :query='gridQuery'
                              :actionComplete="actionCompletegridWithArea"
                              :actionBegin="actionBegin"
                              :queryCellInfo='customiseCell'
                              :dataBound='dataBound'>
                    </ejs-grid>
                    <div>
                        <ejs-uploader ref="uploadObj" id='defaultfileupload' name="uploadFile" :allowedExtensions="extensions" :uploading="addHeaders" :asyncSettings="path" :success="onUploadSuccessgridWithArea" :failure="onUploadFailedgridWithArea" :multiple='multiple'></ejs-uploader>
                    </div>
                </div>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, Aggregate, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { UploaderPlugin } from "@syncfusion/ej2-vue-inputs";
    import SyncHelper from '../../common/syncfusion'
    import gridOptions from '../../common/gridOptions'
    import store from '../../store';
    import { Query } from '@syncfusion/ej2-data'
    import apis from '../../common/network'
    import urls from '../../common/urls'
    import authToken from '../../common/authToken';
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';


    Vue.use(GridPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);

    let selectedRecord = {};

    export default {
        name: 'VolumeForm',
        created() {
            apis.protectedApi(`utils/products?utilityTypeId=${store.state.contractSelectedUtility}`)
                .then(response => {
                    if (response.data) {
                        response.data.forEach(p => {
                            if (store.state.contractProducts.includes(p.id)) {
                                this.selectedProducts.push(p.productName);
                            }
                        })
                    }
                }).catch(e => {
                    if (e.response) {
                        this.showErrorDialog(e.response.data.message);
                    }
                })
            apis.protectedApi(`utils/contractHasAreas?contractId=${store.state.selectedContractId}`)
                .then(response => {
                    if (response.data) {
                        this.hasAreas = response.data.contractHasAreas;
                        this.hasNoAreas = !response.data.contractHasAreas;
                    }
                }).catch(e => {
                    if (e.response) {
                        this.showErrorDialog(e.response.data.message);
                    }
                })
            apis.protectedApi(`utils/contractMainAreaNames?contractId=${store.state.selectedContractId}`)
                .then(response => {
                    if (response.data) {
                        this.mainAreaNames = response.data.mainAreaNames;
                        for (var i = 0; i < this.$refs.gridWithArea.ej2Instances.columns.length; i++) {
                            if (this.mainAreaNames.includes(this.$refs.gridWithArea.ej2Instances.columns[i].field)) {
                                this.$refs.gridWithArea.ej2Instances.columns[i].allowEditing = false;
                            }
                        }
                    }
                }).catch(e => {
                    if (e.response) {
                        this.showErrorDialog(e.response.data.message);
                    }
                })
        },
        data() {
            return {
                volumeData: SyncHelper.getDataManager("volume"),
                volumeUnit: store.state.contractVolumeUnit,
                tradeUnit: store.state.contractTradeUnit,
                volumeUnitName: store.state.contractVolumeUnitName,
                tradeUnitName: store.state.contractTradeUnitName,
                pageSettings: gridOptions.pageSettings,
                gridQuery: new Query().addParams("contractId", store.state.selectedContractId),
                editSettings: {
                    showConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.Volume.Update"],
                    mode: 'Normal'
                },
                selectedProducts: [],
                toolbar: ['Edit', 'ExcelExport'],
                filterOptions: gridOptions.filterSettings,
                numericParams: {
                    params: {
                        decimals: 4,
                        format: "n4",
                        min: 0,
                        change: (args) => this.calculateTotalColumnVolume(args.column.field, args.value)
                    }
                },
                numericBaseParams: {
                    params: {
                        decimals: 4,
                        format: "n4",
                        min: 0,
                        change: this.calculateTotalBaseVolume,
                    }
                },
                numericPeakParams: {
                    params: {
                        decimals: 4,
                        format: "n4",
                        min: 0,
                        change: this.calculateTotalPeakVolume,
                    }
                },
                numericOffPeakParams: {
                    params: {
                        decimals: 4,
                        format: "n4",
                        min: 0,
                        change: this.calculateTotalOffPeakVolume,
                    }
                },
                numericGasParams: {
                    params: {
                        decimals: 4,
                        format: "n4",
                        min: 0,
                        change: this.calculateTotalGasVolume,
                    }
                },
                path: {
                    saveUrl: `${urls.apiBaseUrl}volume/import/?contractId=${store.state.selectedContractId}`
                },
                extensions: ' .xls, .xlsx',
                multiple: false,
                addHeaders: function (args) {
                    args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);

                }, 
                initialRefresh: true,
                hasAreas: true,
                hasNoAreas: true,
                mainAreaNames: []
            }
        },
        methods: {
            dataBound: function () {
                if (this.initialRefresh) {
                    for (var i = 0; i < this.$refs.gridWithArea.ej2Instances.columns.length; i++) {
                        //this.$refs.gridWithArea.ej2Instances.columns[0].width = 120;
                        //this.$refs.gridWithArea.ej2Instances.columns[0].editType = "numericEdit"; 
                        //this.$refs.gridWithArea.ej2Instances.columns[0].format = "n2" 
                        //this.$refs.gridWithArea.ej2Instances.columns[0].edit = "numericBaseParams" 
                        if (this.$refs.gridWithArea.ej2Instances.columns[i].field === "volumeId") {
                            this.$refs.gridWithArea.ej2Instances.columns[i].visible = false;
                            this.$refs.gridWithArea.ej2Instances.columns[i].isPrimaryKey = true;
                        } if (this.$refs.gridWithArea.ej2Instances.columns[i].field === "year") {
                            this.$refs.gridWithArea.ej2Instances.columns[i].visible = false;
                        }
                        if (this.$refs.gridWithArea.ej2Instances.columns[i].field === "periodSpanId") {
                            this.$refs.gridWithArea.ej2Instances.columns[i].visible = false;
                        }
                        if (this.$refs.gridWithArea.ej2Instances.columns[i].field === "periodId") {
                            this.$refs.gridWithArea.ej2Instances.columns[i].visible = false;
                        }
                        if (this.$refs.gridWithArea.ej2Instances.columns[i].field === "contractId") {
                            this.$refs.gridWithArea.ej2Instances.columns[i].visible = false;
                        }
                        if (this.$refs.gridWithArea.ej2Instances.columns[i].field === "base") {
                            this.$refs.gridWithArea.ej2Instances.columns[i].visible = false;
                        }
                        if (this.$refs.gridWithArea.ej2Instances.columns[i].field === "gas") {
                            this.$refs.gridWithArea.ej2Instances.columns[i].visible = false;
                        }
                        if (this.$refs.gridWithArea.ej2Instances.columns[i].field === "offPeak") {
                            this.$refs.gridWithArea.ej2Instances.columns[i].visible = false;
                        }
                        if (this.$refs.gridWithArea.ej2Instances.columns[i].field === "peak") {
                            this.$refs.gridWithArea.ej2Instances.columns[i].visible = false;
                        }
                        if (this.$refs.gridWithArea.ej2Instances.columns[i].field === "total") {
                            this.$refs.gridWithArea.ej2Instances.columns[i].visible = false;
                        }
                        if (this.$refs.gridWithArea.ej2Instances.columns[i].field.startsWith("Total")){
                            this.$refs.gridWithArea.ej2Instances.columns[i].allowEditing = false;
                        }


                        if (this.$refs.gridWithArea.ej2Instances.columns[i].field === "tradablePeriod") {
                            this.$refs.gridWithArea.ej2Instances.columns[i].headerText = 'Tradeable Period';
                            this.$refs.gridWithArea.ej2Instances.columns[i].allowEditing = false;
                        } 
                    }
                    this.updateAggregates();
                    this.$refs.gridWithArea.ej2Instances.refreshColumns();
                    this.$refs.gridWithArea.refresh()
                    this.initialRefresh = false;
                }
            },
            updateAggregates() {
                const gridInstance = this.$refs.gridWithArea.ej2Instances;
                const columnNames = gridInstance.getColumns().map(column => column.field);
                // Generate aggregates based on fetched column data
                var aggregates = [{
                    columns: columnNames.filter(propertyName => propertyName !== 'volumeId' && propertyName !== 'tradablePeriod').map(column => ({
                        type: 'Custom',
                        field: column,
                        customAggregate: this.calculateFooterTootalArea,
                        footerTemplate: this.footerTemplate
                    }))
                }];
                this.$refs.gridWithArea.aggregates = aggregates;
                gridInstance.aggregates = aggregates;
            },
            convertToHeaderText(propertyName) {
                // Convert camelCase to readable text with spaces
                return propertyName.replace(/([A-Z])/g, ' $1').trim();
            },
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {
                    this.$refs.grid.getColumns()[0].visible = true;
                }
                gridOptions.excelExport(args, "Volume.xlsx", this.$refs);

            },
            toolbarClickgridWithArea(args) {
                if (args.item.id.includes('excelexport')) {
                    this.$refs.gridWithArea.getColumns()[0].visible = true;
                } 
                if (args.item.id.includes('excelexport')) {
                    let excelExportProperties = {
                        fileName: "Volume.xlsx"
                    };
                    this.$refs.gridWithArea.showSpinner();
                    this.$refs.gridWithArea.excelExport(excelExportProperties);
                }
            },
            footerTemplate: function () {
                return {
                    template: Vue.component('sumBaseTemplate', {
                        template: `<span>` + (this.showWeightedAvg ? 'Avg:' : 'Sum:') + ` {{data.Custom.toLocaleString('en-US', {maximumFractionDigits:2})}} [${this.volumeUnit}]</span>`,
                        data() { return { data: {} }; }
                    })
                }
            },
            footerTemplateArea: function () {
                return {
                    template: Vue.component('sumBaseTemplate', {
                        template: `<span>` + (this.showWeightedAvg ? 'Avg:1' : 'Sum:0') + `[${this.volumeUnit}]</span>`,
                        data() { return { data: {} }; }
                    })
                }
            },
            calculateTotalBaseVolume: function (args) {
                selectedRecord['base'] = args.value;
                this.refreshFooterTotal(selectedRecord);
            },
            calculateTotalPeakVolume: function (args) {
                selectedRecord['peak'] = args.value;
                this.refreshFooterTotal(selectedRecord);
            },
            calculateTotalOffPeakVolume: function (args) {
                selectedRecord['offPeak'] = args.value;
                this.refreshFooterTotal(selectedRecord);
            },
            calculateTotalGasVolume: function (args) {
                selectedRecord['gas'] = args.value;
                this.refreshFooterTotal(selectedRecord);
            },
            refreshFooterTotal: function (selectedRecord) {
                let gridObj = this.$refs.grid.ej2Instances;
                gridObj.aggregateModule.refresh(selectedRecord);
            },
            refreshFooterTotalgridWithArea: function (selectedRecord) {
                let gridObj = this.$refs.gridWithArea.ej2Instances;
                gridObj.aggregateModule.refresh(selectedRecord);
            },

            calculateSumBase: function (data) {
                return this.calculateFooterTootal(data, 'base');
            },
            calculateSumPeak: function (data) {
                return this.calculateFooterTootal(data, 'peak');
            },
            calculateSumOffPeak: function (data) {
                return this.calculateFooterTootal(data, 'offPeak');
            },
            calculateSumGas: function (data) {
                return this.calculateFooterTootal(data, 'gas');
            },
            calculateSumTotal:  function (data) {
                return this.calculateFooterTootal(data, 'total');
            },
            calculateFooterTootalArea: function(data, product) {
                return this.calculateFooterTootal(data, product.properties.field );
            },
        calculateFooterTootal: function (data, product) {
                var items = data;
                if (data.result != undefined) {
                    items = data.result;
                }
                var valueSum = 0;
                if (this.showWeightedAvg) {
                    var periodTotalSum = 0;
                    var periodSpan = 0;
                    for (var i = 0; i < items.length; i++) {
                        periodSpan = this.getDaysInMonth(items[i].periodSpanId, items[i].year);
                        periodTotalSum += periodSpan;
                        valueSum += items[i][product] * periodSpan;
                    }
                    valueSum = periodTotalSum > 0 ? (valueSum / periodTotalSum) : valueSum;
                } else {
                    for (var i = 0; i < items.length; i++) {
                        valueSum += items[i][product];
                    }
                }
                return valueSum;
            },
            getDaysInMonth: function (month, year) {
                // Here January is 1 based
                //Day 0 is the last day in the previous month
                return new Date(year, month, 0).getDate();
                // Here January is 0 based
                // return new Date(year, month+1, 0).getDate();
            },
            excelExportComplete(args) {
                this.$refs.grid.getColumns()[0].visible = false;
                this.$refs.grid.hideSpinner();
            },
            excelExportCompletegridWithArea(args) {
                this.$refs.gridWithArea.getColumns()[0].visible = false;
                this.$refs.gridWithArea.hideSpinner();
            },
            actionBegin(args) {
                if (args.requestType === 'beginEdit') {
                    selectedRecord = {};
                    selectedRecord = args.rowData;
                }
                //if (args.requestType == 'save') {
                //    if (this.tradeUnitName == '%' && store.state.contractHasActiveTrades && !store.state.percentageAutomaticCalc) {
                //        this.showErrorDialog("Trades have already been entered for this contract and will not be recalculated based on the new volume forecast.");
                //    } 
                //}
            },
            actionComplete(args) { 
                if (args.requestType === 'save') {
                    this.$refs.grid.refresh();
                }

            },
            actionCompletegridWithArea(args) {

                if (args.requestType === 'save') {
                    this.$refs.gridWithArea.refresh();
                }

            },
           
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            onUploadFailed: function (args) {
                this.$refs.grid.refresh();
                var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                args.statusText = statusMessage.trim();
            },
            onUploadFailedgridWithArea: function (args) {
                this.$refs.gridWithArea.refresh();
                var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                args.statusText = statusMessage.trim();
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
            }, 
            onUploadSuccessgridWithArea: function (args) {
                let response = JSON.parse(args.e.currentTarget.response);
                if (response.status === "OK with Errors") {
                    let fileName = JSON.parse(args.e.currentTarget.response).file.fileDownloadName;
                    let base64String = JSON.parse(args.e.currentTarget.response).file.fileContents;
                    const byteCharacters = atob(base64String);
                    const byteNumbers = new Uint8Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const blob = new Blob([byteNumbers], { type: 'application/octet-stream' });
                    const url = window.URL.createObjectURL(blob);
                    const element = document.createElement('a');
                    element.href = url;
                    element.download = fileName;
                    document.body.appendChild(element);
                    element.click();
                    element.remove();
                    window.URL.revokeObjectURL(url);
                    var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                    args.statusText = statusMessage.trim();
                }
                this.$refs.gridWithArea.refresh();
                //if (this.tradeUnitName == '%' && store.state.contractHasActiveTrades && !store.state.percentageAutomaticCalc) {
                //    this.showErrorDialog("Trades have already been entered for this contract and will not be recalculated based on the new volume forecast.");
                //}
            },
            onUploadSuccess: function (args) {
                if (JSON.parse(args.e.currentTarget.response).status === "OK with Errors") {
                    let fileName = JSON.parse(args.e.currentTarget.response).file.fileDownloadName;
                    let base64String = JSON.parse(args.e.currentTarget.response).file.fileContents;
                    const byteCharacters = atob(base64String);
                    const byteNumbers = new Uint8Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const blob = new Blob([byteNumbers], { type: 'application/octet-stream' });
                    const url = window.URL.createObjectURL(blob);
                    const element = document.createElement('a');
                    element.href = url;
                    element.download = fileName;
                    document.body.appendChild(element);
                    element.click();
                    element.remove();
                    window.URL.revokeObjectURL(url);
                    var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                    args.statusText = statusMessage.trim();
                }
                this.$refs.grid.refresh();
                //if (this.tradeUnitName == '%' && store.state.contractHasActiveTrades && !store.state.percentageAutomaticCalc) {
                //    this.showErrorDialog("Trades have already been entered for this contract and will not be recalculated based on the new volume forecast.");
                //}
            },
            customiseCell: function (args) {
                if (args.column.field != 'tradablePeriod' ) {
                    args.cell.textContent = args.cell.textContent + " " + "[" + this.volumeUnit + "]";
                }
            },
            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
        },
        computed: {
            baseVisible() {
                return this.selectedProducts.includes("Baseload");
            },
            peakVisible() {
                return this.selectedProducts.includes("Peakload");
            },
            gasVisible() {
                return this.selectedProducts.includes("Gas");
            },
            offPeakVisible() {
                return this.selectedProducts.includes("Off-Peak");
            },
            totalVisible() {
                return this.selectedProducts.length > 1
            },
            showWeightedAvg: function () {
                return this.volumeUnitName === 'th/d' || this.volumeUnitName === 'MW';
            },
            
        }, 
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, Aggregate, ExcelExport, ForeignKey]
        }
    }
</script>

<style scoped>
</style>